import { Link } from 'react-router-dom';
import { RTBLogo } from '@/components/RTBLogo';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-gray-100 py-4 px-6">
        <Link to="/" className="inline-block"><RTBLogo className="h-8" /></Link>
      </header>
      <div className="max-w-3xl mx-auto px-6 py-12" data-testid="terms-page">
        <h1 className="text-3xl font-oswald font-bold text-gray-900 mb-8">Terms of Service</h1>
        <div className="prose prose-gray max-w-none text-gray-600 space-y-6 text-sm leading-relaxed">
          <p><strong>Last Updated:</strong> March 25, 2026</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">1. Acceptance of Terms</h2>
          <p>By accessing or using ReadyToBuildIt.life ("RTBI," "we," "us," or "our"), you agree to be bound by these Terms of Service. If you do not agree, do not use this platform.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">2. Description of Service</h2>
          <p>RTBI provides a 20-day mentorship and education program focused on business development, LLC formation, and entrepreneurial skills. The program includes online coursework, mentoring sessions, and supporting materials.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">3. Eligibility</h2>
          <p>You must be at least 18 years of age and capable of forming a binding contract. By registering, you represent and warrant that you meet these requirements.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">4. Account Registration</h2>
          <p>You agree to provide accurate, current, and complete information during registration and to update such information to keep it accurate. You are responsible for maintaining the confidentiality of your account credentials.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">5. Payment Terms</h2>
          <p>The program fee is $75 USD, payable via our designated payment processor (Whop). All payments are non-refundable unless otherwise stated in our Refund Policy. By making a payment, you authorize us to charge your selected payment method.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">6. Program Content</h2>
          <p>All content provided through the RTBI program is for educational and informational purposes only. We do not guarantee any specific results or outcomes. Success depends on individual effort, market conditions, and other factors beyond our control.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">7. Intellectual Property</h2>
          <p>All content, materials, trademarks, and intellectual property on this platform are owned by or licensed to RTBI. You may not reproduce, distribute, or create derivative works without our express written permission.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">8. User Conduct</h2>
          <p>You agree not to: (a) use the platform for any unlawful purpose; (b) share your account credentials with third parties; (c) attempt to gain unauthorized access to our systems; (d) harass, abuse, or harm other users; (e) distribute program materials without authorization.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">9. Limitation of Liability</h2>
          <p>TO THE MAXIMUM EXTENT PERMITTED BY LAW, RTBI SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF THE PLATFORM OR PROGRAM.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">10. Termination</h2>
          <p>We reserve the right to suspend or terminate your account at our sole discretion, without prior notice, for conduct that we determine violates these Terms or is harmful to other users or our business interests.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">11. Governing Law</h2>
          <p>These Terms shall be governed by and construed in accordance with the laws of the United States, without regard to conflict of law provisions.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">12. Contact</h2>
          <p>For questions about these Terms, contact us at <a href="mailto:support@readytobuildit.life" className="text-rtb-purple">support@readytobuildit.life</a>.</p>
        </div>
      </div>
    </div>
  );
}
